export default function () {
  return {
    part_no: null,
    vendor_id: null,
    vendor_project_id: null,
    product_category_id: null,
    productDatas: null,
    datas: [],
    status: '',
  }
}